export const superPermission = "super";

export const getUserPermissionsList = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const features = (user && user.features) || [];
  const role = user && user.role;

  const permissions = features.length > 0 ? [...features, role] : [role];
  return permissions;
};

export const userHasEveryPermissions = (permissionList) => {
  const userPermissionList = getUserPermissionsList();

  const userDoesHavePermissions = permissionList.every((permission) => {
    return userPermissionList.includes(permission);
  });

  return userDoesHavePermissions;
};

export const userHasSomePermissions = (permissionList) => {
  const userPermissionList = getUserPermissionsList();

  const userDoesHavePermissions = userPermissionList.some((permission) => {
    return permissionList.includes(permission);
  });

  return userDoesHavePermissions;
};

export const userHasMicrosoftAuthPermission = () => {
  const microsoftAuthClients = ["realerisk"];

  const currClient = process.env.REACT_APP_ENVIRONMENT;

  return microsoftAuthClients.includes(currClient.toLocaleLowerCase());
};
